function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "14.55 21.97 9.87 21.97 9.87 6.38 21.71 6.38 21.71 21.05",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.61,9.22V26l7.52-3.84V6Zm3.69,9.31H17V16H18.3Z",
    style: {
      fill: "#8e6335"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAway);
export default __webpack_public_path__ + "static/media/presence-away.00ff16b4.svg";
export { ForwardRef as ReactComponent };